import React from "react";
import { I18nProvider } from "src/utils/localization/languages/I18nContext";
import { languageFromCode } from "src/utils/localization/languages/languages";
import { LanguageCode } from "src/utils/localization/languages/types";
import { LocationProvider } from "@gatsbyjs/reach-router";

type Props = {
  languageCode: LanguageCode;
};

const SliceProviders: React.FC<React.PropsWithChildren<Props>> = ({
  languageCode,
  children
}) => {
  const language = languageFromCode(languageCode);
  return (
    <LocationProvider>
      <I18nProvider language={language}>{children}</I18nProvider>
    </LocationProvider>
  );
};

export default SliceProviders;
